import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=829b9810&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=829b9810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829b9810",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('829b9810')) {
      api.createRecord('829b9810', component.options)
    } else {
      api.reload('829b9810', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=829b9810&scoped=true&", function () {
      api.rerender('829b9810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23hFhlu25PbqV/JS/comp/PopupBox.vue"
export default component.exports